import { NetworkStatus } from '@cbridge-utils/network';
import { IDictTimezoneState } from './dictTimezone.interface';

export const initialState: IDictTimezoneState = {
  list: [],
  networkStatus: NetworkStatus.Started,
};
